import SplitSection from "./SplitSection";

// Body text with a supporting image held to one side. An image the content
// gives no alt text to is decorative, and says so rather than sitting in the
// accessibility tree unnamed.
export default function ImageSection(props: { section: CaseStudyImageSectionT }) {
  const { title, side, body, image_Url, imageAlt } = props.section;

  const image = (
    <img
      className="case-image"
      src={image_Url}
      alt={imageAlt || ""}
      role={imageAlt ? undefined : "presentation"}
    />
  );

  return (
    <SplitSection variant="image" title={title} side={side} aside={image}>
      {body ? <p className="case-body">{body}</p> : null}
    </SplitSection>
  );
}
